import { render, staticRenderFns } from "./FundPerformanceChart.vue?vue&type=template&id=5060f20f&"
import script from "./FundPerformanceChart.vue?vue&type=script&lang=ts&"
export * from "./FundPerformanceChart.vue?vue&type=script&lang=ts&"
import style0 from "./FundPerformanceChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports